export const info_dsa = {
  address_line: {
    label: 'Indirizzo',
    icon: '',
    visible: true,
  },
  city: {
    label: 'Citta',
    icon: '',
    visible: true,
  },
  country: {
    label: 'Paese',
    icon: '',
    visible: true,
  },
  post_code: {
    label: 'Codice postale',
    icon: '',
    visible: true,
  },
  email: {
    label: 'Email',
    icon: '',
    visible: false,
  },
  name: {
    label: 'Nome',
    icon: '',
    visible: true,
  },
  registration_number: {
    label: 'Numero di registro',
    icon: '',
    visible: true,
  },
  telephone: {
    label: 'Telefono',
    icon: '',
    visible: true,
  },
  trade_register: {
    label: 'Registro delle imprese',
    icon: '',
    visible: true,
  },
  trader_verified: {
    label: 'Struttura verificata',
    icon: '',
    visible: true,
  },
}

export function get_info_dsa(key) {
  if (info_dsa[key] !== undefined) return info_dsa[key]
  return {
    label: key,
    icon: "symbol_vv",
    visible: true
  }
}